import { IShowCheckOrganizationParams } from "src/models";
import CheckOrganization from "src/components/CheckOrganization/CheckOrganization";

export default {
    checkOrganizationComponent: null,

    dispose() {
        if (this.checkOrganizationComponent) {
            this.checkOrganizationComponent.dispose();
        }
        this.checkOrganizationComponent = null;
    },

    show(params: IShowCheckOrganizationParams) {
        if (!this.checkOrganizationComponent) {
            this.checkOrganizationComponent = new CheckOrganization({
                source: '<x-check-organization></x-check-organization>'
            });
            this.checkOrganizationComponent.attach(document.body);
        }
        this.checkOrganizationComponent.show(params)
    }
};
